import React from 'react';
import { useDashboardVariant } from '../../data/domains/config';
import { DashboardNutritionCardSet1 } from './variants/set1/DashboardNutritionCardSet1';
import { DashboardNutritionCardSet3 } from './variants/set3/DashboardNutritionCardSet3';
import type { ThemeColors } from '../../shared/theme';

interface MacroTotals {
  calories: number;
  protein: number;
  carbs: number;
  fats: number;
}

interface DayConfigStub {
  min_calories?: number;
  max_calories?: number;
}

export interface DashboardNutritionCardProps {
  macro_totals: MacroTotals;
  day_config: DayConfigStub | null;
  selected_date: string;
  colors: ThemeColors;
  is_empty: boolean;
}

export function DashboardNutritionCard(props: DashboardNutritionCardProps) {
  const variant = useDashboardVariant();

  if (variant === 'set2') {
    return null;
  }
  if (variant === 'set1') {
    return <DashboardNutritionCardSet1 {...props} />;
  }
  return <DashboardNutritionCardSet3 {...props} />;
}
